<template lang="html">
  <div class="item column" :class="{ red: (prog < 0) }" style="position:relative;">
    <div class="item-title">
      {{ title }}
    </div>
    <div class="ctn-values row">
<!--      <div class="value">-->
<!--        {{ value }}-->
<!--      </div>-->
      <div class="value" v-if="title !== 'Mes revenus perçus depuis que je suis client'">
				{{ prog }} %
      </div>
      <div class="value" v-if="title === 'Mes revenus perçus depuis que je suis client'">
				{{formatCurrency( prog )}}
      </div>
      <div class="prog">
        <span v-if="(prog >= 0)"><img :src="good" alt=""></span>
        <span v-else><img :src="bad" alt=""></span>
      </div>
    </div>
    <div class="progress-bar" v-if="title !== 'Mes revenus perçus depuis que je suis client'">
      <div class="inner-bar" :style="{ width: Math.abs(prog) + '%' }"></div>
    </div>
    <div v-if="title === 'Mes revenus perçus depuis que je suis client'"
      id="global-perf-help-modal"
      class="dot"
      @click="toggleGlobalPerfHelpModal"
    />
  </div>
</template>

<script>
import Good from '@/common/assets/img/high-icon.svg'
import Bad from '@/common/assets/img/down-icon.svg'
import Driver from 'driver.js'
import CurrencyHelper from '@/common/utils/currency-helper'

export default {
	props: ['title', 'value', 'prog'],
	data () {
		return {
			good: Good,
			bad: Bad,
      driver: null,
		}
	},
  mounted () {
    this.driver = new Driver({
      animation: true,
      opacity: 0,
      closeBtnText: 'Fermer',
      nextBtnText: 'Suivant',
      prevBtnText: 'Précédent',
      allowClose: true
    })
  },
  methods: {
			formatCurrency(number, symbol = null) {
      if (symbol) {
        return CurrencyHelper.formatCurrency(number, symbol);
      }

      return CurrencyHelper.formatCurrency(number, "€");
    },
    toggleGlobalPerfHelpModal () {
      this.driver.highlight({
        element: '#global-perf-help-modal',
        popover: {
          title: 'Performance globale',
          description: 'Vos revenus perçus (par exemple de parts de SCPI) sont désormais intégrés dans vos performances globales.'
        }
      })
    }
  }
}
</script>

<style lang="css">
.dot {
  background: #cca92cc4;
  border-radius: 50%;
  cursor: pointer;
  width: 15px;
  height: 15px;
  animation: pulse 2s infinite;
  position: absolute;
  top: 0px;
  right: 1rem;
}
</style>



// WEBPACK FOOTER //
// performance-stat.vue?3dc903dc